import {
  Page,
  Document,
  PDFViewer,
  View,
  Text,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

const data = {
  cliente: "Dahadson S.R.L.",
  nit: "346397024",
  contacto: "",
  numero: "SCZ-2025-0044",
  fecha: "01/07/2025",
  operador: "jose luis morales",
  aduana: "201 (interior la paz)",
  regimenAduanero: "importacion a consumo",
  modDespacho: "general",
  descripcio:
    "225 CAJAS DE CARTON QUE CONTIENEN 75 MOTOCICLETAS MODELO KD250-5A (45) Y KD300-5B (30)",
  documento: [
    {
      doc: "BILL OF LADING (BL)-CONOCIMIENTO DE EMBARQUE MARITIMO",
      numDoc: "MEDURV343393",
      tipo: "FOT",
    },
    { doc: "LISTA DE EMPAQUE", numDoc: "MH07WMK2412-10 ", tipo: "FOT" },
    { doc: "FACTURA COMERCIAL", numDoc: "MH07WMK2412-10 ", tipo: "FOT" },
  ],
  observacione: [{ obs: "realizar dim" }, { obs: "realizar dam" }],
};

const styles = StyleSheet.create({
  page: {
    padding: "30px 30px",
    fontSize: 7.5,
  },
  seccion: {
    borderWidth: 1,
    width: "100%",
    height: "100%",
  },
  contenedor: {
    borderBottom: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    minHeight: 38,
    padding: 5,
  },
  contenedor1: {
    flexDirection: "column",
    flex: 1,
    gap: 6,
  },
  contenedor2: {
    flexDirection: "row",
    flex: 1,
  },
  caja: {
    flex: 1,
    flexDirection: "row",
    borderRight: 1,
  },
  celda: {
    flex: 1,
    alignSelf: "center",
  },
  img: {
    width: 120,
    alignSelf: "center",
    padding: 5,
  },
  title: {
    textAlign: "center",
    fontWeight: "600",
    fontSize: 15,
  },
  text: {
    textAlign: "center",
  },
  text1: {
    fontWeight: "bold",
    textAlign: "right",
    flex: 2,
    paddingRight: 10,
  },
  tabla: {
    borderBottom: 1,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  footer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: 150,
  },
});

function WorksheetForm() {
  const MyDoc = ({ data }) => (
    <Document>
      <Page size="LETTER" style={styles.page}>
        <View style={{ ...styles.seccion }}>
          <View style={{ ...styles.contenedor, padding: 0 }}>
            <View style={{ ...styles.caja }}>
              <View style={{ ...styles.celda }}>
                <Image
                  src={require("../../assets/LogoSCzPlus.png")}
                  style={{ ...styles.img }}
                />
              </View>
            </View>
            <View style={{ ...styles.caja, flex: 2 }}>
              <View style={{ ...styles.celda }}>
                <Text style={{ ...styles.title }}>HOJA DE TRABAJO</Text>
              </View>
            </View>
            <View style={{ ...styles.caja, borderRight: 0 }}>
              <View style={{ ...styles.celda }}>
                <Text style={{ ...styles.text, fontWeight: "bold" }}>
                  {data.numero}
                </Text>
              </View>
            </View>
          </View>
          <View style={{ ...styles.contenedor }}>
            <View style={{ ...styles.contenedor1, flex: 2 }}>
              <View style={{ ...styles.contenedor2 }}>
                <Text style={{ ...styles.text1, flex: 1 }}>CLIENTE:</Text>
                <Text style={{ flex: 3 }}>
                  {data?.cliente.toUpperCase() || ""}
                </Text>
              </View>
              <View style={{ ...styles.contenedor2 }}>
                <Text style={{ ...styles.text1, flex: 1 }}>CONTACTO:</Text>
                <Text style={{ flex: 3 }}>
                  {data?.contacto.toUpperCase() || ""}
                </Text>
              </View>
            </View>
            <View style={{ ...styles.contenedor1, flex: 2 }}>
              <View style={{ ...styles.contenedor2 }}>
                <Text style={{ ...styles.text1, flex: 4 }}>NIT:</Text>
                <Text style={{ ...styles.text, flex: 2 }}>
                  {data?.nit || ""}
                </Text>
              </View>
              <View style={{ ...styles.contenedor2 }}>
                <Text style={{ ...styles.text1, flex: 4 }}>FECHA:</Text>
                <Text style={{ ...styles.text, flex: 2 }}>
                  {data?.fecha || ""}
                </Text>
              </View>
            </View>
          </View>
          <View style={{ ...styles.contenedor }}>
            <View style={{ ...styles.contenedor1, flex: 2 }}>
              <View style={{ ...styles.contenedor2 }}>
                <Text style={{ ...styles.text1, flex: 1 }}>OPERADOR:</Text>
                <Text style={{ flex: 3 }}>
                  {data?.operador.toUpperCase() || ""}
                </Text>
              </View>
              <View style={{ ...styles.contenedor2 }}>
                <Text style={{ ...styles.text1, flex: 1 }}>ADUANA:</Text>
                <Text style={{ flex: 3 }}>
                  {data?.aduana.toUpperCase() || ""}
                </Text>
              </View>
            </View>
            <View style={{ ...styles.contenedor1, flex: 2 }}>
              <View style={{ ...styles.contenedor2 }}>
                <Text style={{ ...styles.text1 }}>REGIMEN ADUANERO:</Text>
                <Text style={{ flex: 4 }}>
                  {data?.regimenAduanero.toUpperCase() || ""}
                </Text>
              </View>
              <View style={{ ...styles.contenedor2 }}>
                <Text style={{ ...styles.text1 }}>MOD. DESPACHO:</Text>
                <Text style={{ flex: 4 }}>
                  {data?.modDespacho.toUpperCase() || ""}
                </Text>
              </View>
            </View>
          </View>
          <View style={{ ...styles.contenedor }}>
            <View style={{ ...styles.contenedor1 }}>
              <Text style={{ textAlign: "left", fontWeight: "bold" }}>
                DESCRIPCIÓN DE LA MERCADERÍA:
              </Text>
              <Text style={{ textAlign: "center" }}>
                {data?.descripcio.toUpperCase() || ""}
              </Text>
            </View>
          </View>
          <View style={{ ...styles.tabla, padding: 5 }}>
            <View style={{ ...styles.caja, flex: 2, borderRight: 0 }}>
              <View style={{ ...styles.celda }}>
                <Text style={{ textAlign: "left", fontWeight: "bold" }}>
                  HOJA DE TRABAJO
                </Text>
              </View>
            </View>
            <View style={{ ...styles.caja, borderRight: 0 }}>
              <View style={{ ...styles.celda }}>
                <Text style={{ ...styles.text, fontWeight: "bold" }}>
                  HOJA DE TRABAJO
                </Text>
              </View>
            </View>
            <View style={{ ...styles.caja, borderRight: 0 }}>
              <View style={{ ...styles.celda }}>
                <Text style={{ ...styles.text, fontWeight: "bold" }}>TIPO</Text>
              </View>
            </View>
          </View>
          {data.documento.map((item, index) => (
            <View
              key={index}
              style={{
                ...styles.tabla,
                borderBottom: 0,
                paddingHorizontal: 5,
                paddingVertical: 3,
                backgroundColor: index % 2 === 0 ? "#f0f0f0" : "#ffffff",
              }}
            >
              <View style={{ ...styles.caja, flex: 2, borderRight: 0 }}>
                <View style={{ ...styles.celda }}>
                  <Text style={{ textAlign: "left" }}>
                    {item?.doc.toUpperCase() || ""}
                  </Text>
                </View>
              </View>
              <View style={{ ...styles.caja, borderRight: 0 }}>
                <View style={{ ...styles.celda }}>
                  <Text style={{ ...styles.text }}>
                    {item?.numDoc.toUpperCase() || ""}
                  </Text>
                </View>
              </View>
              <View style={{ ...styles.caja, borderRight: 0 }}>
                <View style={{ ...styles.celda }}>
                  <Text style={{ ...styles.text }}>
                    {item?.tipo.toUpperCase() || ""}
                  </Text>
                </View>
              </View>
            </View>
          ))}
          <View style={styles.footer}>
            <View style={{ borderTop: 1, padding: 5 }}>
              <Text
                style={{ fontWeight: "bold", textAlign: "center", fontSize: 9 }}
              >
                COMENTARIOS
              </Text>
              <Text
                style={{
                  fontWeight: "bold",
                  textAlign: "left",
                  marginBottom: 2,
                }}
              >
                OBSERVACIONES:
              </Text>
              {data.observacione.map((item, index) => (
                <View
                  key={index}
                  style={{ paddingHorizontal: 10, paddingVertical: 2 }}
                >
                  <Text style={{ textAlign: "left" }}>
                    {item?.obs.toUpperCase() || ""}
                  </Text>
                </View>
              ))}
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
  return (
    <div>
      {data && (
        <PDFViewer
          style={{
            width: 900,
            height: window.innerHeight - 100,
          }}
        >
          <MyDoc data={data} />
        </PDFViewer>
      )}
    </div>
  );
}

export default WorksheetForm;
